// hooks/useLineChartData.js

import { getValueFromRawData } from "../utils/utils";

/**
 * Hook to process raw data into a format suitable for a LineChart.
 * @param {Array} rawData - The raw data fetched from the API.
 * @param {string} category - The category for which assets should be analyzed, like 'Balcony' or 'Power_0_10'.
 * @returns {{
 *   data: Array<{ year: number, value: number }>,
 *   error: Error|null,
 *   loading: boolean
 * }}
 */
export const useLineChartData = (rawData, energySource, category) => {
  if (!rawData) {
    return { data: [], error: null, loading: true };
  }

  try {
    const key = `${energySource.toUpperCase()}_${category}_Annual_Progression`;
    const progression = getValueFromRawData(rawData, key);

    if (!Array.isArray(progression)) {
      throw new Error(`Expected array at '${key}', got ${typeof progression}`);
    }

    const lineChartData = progression.map(({ year, value }) => ({
      year,
      value,
    }));

    return {
      data: lineChartData,
      error: null,
      loading: false,
    };
  } catch (err) {
    console.error("Error processing LineChart data:", err);
    return { data: [], error: err, loading: false };
  }
};
